import PropTypes from 'prop-types'
import { Element } from '../../html/element'
import { Responsive } from '../../Responsive'
import classes from './index.module.scss'
import { List } from './List'

export const Vertical = ({ list, isChildren }) => {
  const renderVertical = (width) => {
    return (
      <Element
        className={classes.container}
        style={{ backgroundColor: '#EBEBEB', width }}
      >
        <List list={list} isChildren={isChildren} />
      </Element>
    )
  }

  return (
    <Responsive renderResponsive={() => renderVertical(180)}>
      {renderVertical()}
    </Responsive>
  )
}

Vertical.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isI18n: PropTypes.bool,
      route: PropTypes.string,
      keepQueryStrParams: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
  isChildren: PropTypes.bool,
}

Vertical.defaultProps = {
  isChildren: false,
}
